module.exports = __webpack_public_path__ + "img/seastheday.34f4bced.jpg";